module.exports = __webpack_public_path__ + "static/img/coverImage1.47eb73ee.jpg";